import React from 'react'

import {
  Box,
  Button,
  ButtonColorVariant,
  ButtonVariant,
  Color,
  Display,
  DisplayPosition,
  FontWeight,
  Heading3,
  Image,
  JustifyContent,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import mobileImage from '../assets/mobile.webp'

const CloseButton = withCitrusTheme(Button, (theme) => ({
  color: theme.color(Color.Secondary_200),
}))

type MobileHeroProps = {
  message: string
  onDismiss: () => void
}

export const MobileHero = ({ message, onDismiss }: MobileHeroProps) => (
  <Box
    display={[Display.Block, null, Display.None]}
    position={DisplayPosition.Relative}
    bg={Color.ColdGrey_800}
  >
    <Image src={mobileImage} alt="" width="100%" style={{ display: 'block' }} />
    <Box
      position={DisplayPosition.Absolute}
      top="0"
      left="0"
      right="0"
      display={Display.Flex}
      justifyContent={JustifyContent.Center}
      style={{ paddingTop: '18px' }}
    >
      <Heading3 size={7} color={Color.White} fontWeight={FontWeight.Bold}>
        {message}
      </Heading3>
    </Box>
    <Box position={DisplayPosition.Absolute} top="12px" right="12px">
      <CloseButton
        aria-label="Close"
        colorVariant={ButtonColorVariant.Tertiary}
        icon="close"
        onClick={onDismiss}
        variant={ButtonVariant.Icon}
      />
    </Box>
  </Box>
)
